import store from '@/store'

export default [
  {
    path: '/abouts',
    name: 'about',
    component: () => import('@/pages/about/index.vue')
  },
  {
    path: '/abouts/create',
    name: 'about-create',
    component: () => import('@/pages/about/create.vue')
  },
  {
    path: '/abouts/:id',
    name: 'about-edit',
    component: () => import('@/pages/about/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('about/find', to.params.id)
      next()
    }
  }
]
